<template>
    <div class="tw-shrink-0 tw-w-[150px] lg:tw-w-1/4 xl:tw-w-1/6 tw-pr-4 tw-flex tw-flex-col tw-items-center tw-animate-pulse">
        <div class="tw-w-full tw-rounded-full tw-h-[340px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039]"></div>
        <div class="tw-mt-2 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-[150px] tw-h-6 tw-mb-1"></div>
        <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-[100px] tw-h-6"></div>
    </div>
</template>
